import { render, staticRenderFns } from "./StationDetailsPage.vue?vue&type=template&id=358ff41f&scoped=true"
import script from "./StationDetailsPage.vue?vue&type=script&lang=js"
export * from "./StationDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./StationDetailsPage.vue?vue&type=style&index=0&id=358ff41f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ff41f",
  null
  
)

export default component.exports